define('modules/accounts/users/collection',['require','exports','module','app','env','base/collection'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");
    var BaseCollection = require("base/collection");

    var Collection = BaseCollection.extend({
        initialize: function() {
            this.initRequestEvents();
        },
        url: function() {
            return Config.backendUrl + "/accounts/users";
        },
        parse: function(response, options) {
            var users = response._embedded.users;
            return users;
        }
    });

    module.exports = Collection;
});

